import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin/:gameId',
    name: 'Admin',
    component: () => import('../views/Admin.vue')
  },
  {
    path: '/play/:gameId',
    name: 'Play',
    component: () => import('../views/Play.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
